import { apiClient } from './client';
import { Team, CreateTeamData, UpdateTeamData, TeamFilters } from './teamTypes';

export class TeamService {
  // Get all teams with optional filters
  static async getTeams(filters?: TeamFilters): Promise<Team[]> {
    const params: Record<string, any> = {};
    
    if (filters) {
      if (filters.TeamName) params.teamName = filters.TeamName;
      if (filters.UnitID) params.unitId = filters.UnitID;
      if (filters.CompID) params.compId = filters.CompID;
      if (filters.ManagerUsers) params.managerUsers = filters.ManagerUsers;
    }

    const response = await apiClient.get('/teams', params);
    return response.data;
  }

  // Get a single team by ID
  static async getTeamById(id: string): Promise<Team | null> {
    try {
      const response = await apiClient.get(`/teams/${id}`);
      return response.data;
    } catch (error) {
      if (error instanceof Error && error.message.includes('404')) {
        return null;
      }
      throw error;
    }
  }

  // Create a new team
  static async createTeam(teamData: CreateTeamData): Promise<Team> {
    const response = await apiClient.post('/teams', teamData);
    return response.data;
  }

  // Update an existing team
  static async updateTeam(teamData: UpdateTeamData): Promise<Team | null> {
    try {
      const { ID, ...updateFields } = teamData;
      const response = await apiClient.put(`/teams/${ID}`, updateFields);
      return response.data;
    } catch (error) {
      if (error instanceof Error && error.message.includes('404')) {
        return null;
      }
      throw error;
    }
  }

  // Delete a team
  static async deleteTeam(id: string): Promise<boolean> {
    try {
      await apiClient.delete(`/teams/${id}`);
      return true;
    } catch (error) {
      if (error instanceof Error && error.message.includes('404')) {
        return false;
      }
      throw error;
    }
  }

  // Get teams by unit
  static async getTeamsByUnit(unitId: string): Promise<Team[]> {
    return this.getTeams({
      UnitID: unitId
    });
  }

  // Get teams by company
  static async getTeamsByCompany(compId: string): Promise<Team[]> {
    return this.getTeams({
      CompID: compId
    });
  }

  // Search teams by name
  static async searchTeamsByName(teamName: string): Promise<Team[]> {
    return this.getTeams({
      TeamName: teamName
    });
  }
}
